module.exports = __webpack_public_path__ + "img/ico-question.ca915b8c.svg";